import React from 'react';

import CasinoIcon from '../../../../../assets/icons/filters/casino.svg';
import Co2Icon from '../../../../../assets/icons/filters/co2.svg';
import CompostIcon from '../../../../../assets/icons/filters/compost.svg';
import GavelIcon from '../../../../../assets/icons/filters/gavel.svg';
import GppBadIcon from '../../../../../assets/icons/filters/gpp_bad.svg';

export const icons = {
  casino: <img src={CasinoIcon} alt="casino.svg" />,
  co2: <img src={Co2Icon} alt="co2.svg" />,
  gppBad: <img src={GppBadIcon} alt="gppBad.svg" />,
  gavel: <img src={GavelIcon} alt="gavel.svg" />,
  compost: <img src={CompostIcon} alt="compost.svg" />,
};

interface Props {
  icon: keyof typeof icons;
}

const FilterIcon: React.FC<Props> = ({ icon }) => {
  return <>{icons[icon]}</>;
};

export default FilterIcon;
